module.exports = __webpack_public_path__ + "img/飞船.9b8a5d2b.png";